const MulticastGroup = () => import(/* webpackChunkName: "v-multicastGroup" */ '@/components/page/multicastGroup/MulticastGroup')
const Overview = () => import(/* webpackChunkName: "v-multicastGroup" */ '@/components/page/multicastGroup/overview/Overview')
const DataDown = () => import(/* webpackChunkName: "v-multicastGroup" */ '@/components/page/multicastGroup/DataDown')

const routes = [
  {
    path: 'multicast-groups/:id',
    component: MulticastGroup,
    props: true,
    children: [
      {
        path: '',
        name: 'multicastGroup',
        redirect: 'overview'
      }, {
        path: 'overview',
        name: 'multicastGroupOverview',
        props: true,
        component: Overview
      }, {
        path: 'data-down',
        name: 'multicastDataDown',
        props: true,
        component: DataDown,
        meta: {
          hasFloatingButton: true
        }
      }
    ]
  }
]

export default routes
